export default __webpack_public_path__ + "static/media/loader.1548f3cc.gif";